import { useLocation } from 'react-router-dom';

// material-ui
import { Box, ButtonBase } from '@mui/material';

// project imports
import config from './../../../config';
import Logo from './../../../components/common/Logo';
import logoPortalSrc from '../../../assets/images/logo_portal.svg';
import { ROUTES } from '../../../constants';
import { useElectricPage } from '../../../helpers/isElectricPage';

//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSection = ({ disabled, variant = 'default' }) => {
    const isElectricPage = useElectricPage();
    const isUserLoggedIn = Boolean(localStorage.getItem('token'));
    const { pathname } = useLocation();
    const location = useLocation();
    const fromElectricHeader = location.state?.fromElectricHeader;
    const isOnContractBase = pathname === ROUTES.CONTRACT.BASE;

    const linkPath = (() => {
        if (isElectricPage || fromElectricHeader) return ROUTES.ELECTRIC.BASE;
        if (isUserLoggedIn) return ROUTES.CONTRACT.BASE;
        return config.defaultPath;
    })();

    const isDisabled = disabled || (isOnContractBase && isUserLoggedIn);

    return (
        <ButtonBase
            disableRipple
            component="a"
            href={linkPath}
            disabled={isDisabled}
            sx={
                variant === 'portalLogo'
                    ? {
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 'auto',
                          minWidth: 'auto',
                          maxWidth: '100%'
                      }
                    : undefined
            }
        >
            {variant === 'portalLogo' ? (
                <Box
                    component="img"
                    src={logoPortalSrc}
                    alt="しろくま電力"
                    sx={{
                        maxHeight: 48,
                        height: 'auto',
                        width: 'auto',
                        minWidth: 120,
                        display: 'block',
                        objectFit: 'contain'
                    }}
                />
            ) : (
                <Logo />
            )}
        </ButtonBase>
    );
};

export default LogoSection;
